import { render, staticRenderFns } from "./FCCCompetitionMessages.vue?vue&type=template&id=4f959a24"
import script from "./FCCCompetitionMessages.vue?vue&type=script&lang=js"
export * from "./FCCCompetitionMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports